// extracted by mini-css-extract-plugin
module.exports =  {"value":"yYL4bIoujDN_cUgZRHBL"};